export default {"src":"https://cloudflare.edhrec.com/_next/static/media/crossword.ca8d6cfd.svg","height":582,"width":752,"blurWidth":0,"blurHeight":0};